import { GET_CATEGORY } from "./category";

let idIndex = 0;

const itemFactory = ({ id, sizeAlias = 'large', name, birthday, avatar, gender, breed, isEvaluationRequired = false } = {}) => {
  idIndex += 1;

  return {
    "id": id ?? idIndex,
    "categoryAlias": GET_CATEGORY(sizeAlias).categoryAlias,
    "categoryTitle": GET_CATEGORY(sizeAlias).categoryTitle,
    "sizeAlias": GET_CATEGORY(sizeAlias).sizeAlias,
    "sizeTitle": GET_CATEGORY(sizeAlias).sizeTitle,
    "name": name ?? "小白",
    "birthday": birthday ?? null,
    "avatar": avatar ?? "https://assets.codepen.io/1759070/pet-1%402x.png",
    "gender": gender ?? "male",
    "breed": breed ?? null,
    "isEvaluationRequired": isEvaluationRequired,
  }
};

export const PET_LIST = [
  itemFactory({
    "sizeAlias": "large",
    "name": "小白",
    "birthday": null,
    "avatar": "https://assets.codepen.io/1759070/pet-1%402x.png",
    "gender": "male",
    "breed": null
  }),
  itemFactory({
    "sizeAlias": "mini",
    "name": "小白 2世",
    "birthday": null,
    "avatar": "https://assets.codepen.io/1759070/pet-2%402x.png",
    "gender": "female",
    "breed": null
  }),
  itemFactory({
    "sizeAlias": "mini",
    "name": "小白 22世",
    "birthday": null,
    "avatar": "https://assets.codepen.io/1759070/pet-2%402x.png",
    "gender": "female",
    "breed": null
  }),
  itemFactory({
    "sizeAlias": "long",
    "name": "小白 3世",
    "birthday": "2021-08-10",
    "avatar": "https://assets.codepen.io/1759070/pet-3%402x.png",
    "gender": "female",
    "breed": null
  }),
  itemFactory({
    "sizeAlias": "small",
    "name": "小白 4世",
    "birthday": "2021-08-10",
    "avatar": "https://assets.codepen.io/1759070/pet-1%402x.png",
    "gender": "female",
    "breed": null
  }),
];

export const PET_ITEM = itemFactory({
  "id": 1
});

export const PET_AVATAR = "https://assets.codepen.io/1759070/pet-1%402x.png";
